<template>
    <div :class="className" :style="{height:eHeight,width:width}" />
</template>
<script>
import * as echarts from 'echarts'
require('echarts/theme/macarons') // echarts theme
import resize from './mixins/resize'

export default {
    mixins: [resize],
    props: {
        className: {
            type: String,
            default: 'chart'
        },
        width: {
            type: String,
            default: '100%'
        },
        eHeight: {
            type: String,
            default: '100%'
        },
        autoResize: {
            type: Boolean,
            default: true
        },
        chartData: {
            type: Object,
            required: false
        }
    },
    data() {
        return {
            chart: null
        }
    },
    watch: {
        chartData: {
            deep: true,
            handler(val) {
                this.setOptions(val)
            }
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.initChart()
        })
    },
    beforeDestroy() {
        if (!this.chart) {
            return
        }
        this.chart.dispose()
        this.chart = null
    },
    methods: {

        initChart() {
            this.chart = echarts.init(this.$el, 'macarons')
            this.setOptions(this.chartData || {})
        },
        setOptions(data) {
            let arr = [13, 30, 20, 12, 43, 22, 111,13, 30, 20, 12, 43, 22, 111,13, 30, 20, 12, 43, 22, 111];
            let option = {
                grid: {
                    left: 20,
                    right: 20,
                    top: '0%',
                    bottom: 20
                },
                tooltip: {
                  backgroundColor:'rgba(255,255,255,1)'
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    axisLine: {
                        show: false
                    },
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        show: false
                    },
                    splitArea: {
                        show: false
                    },
                    // data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
                },
                yAxis: {
                    show: false,
                    type: 'value',
                    axisLine: {
                        show: false
                    },
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        show: false
                    },
                    splitArea: {
                        show: false
                    },
                    splitLine: {
                        show: false
                    }
                },
                dataZoom: [{
                    type: 'inside',
                    show: false,
                    startValue: 0,
                    endValue: 6
                }],
                series: [{
                    data: arr,
                    type: 'line',
                    symbol: 'none',
                    areaStyle: {
                        color: '#3d9cff'
                    }, 
                    lineStyle: {
                        color: '#3d9cff'
                    }
                }],
                animationDuration: 0,
                animationDurationUpdate: 100,
                animationEasing: 'linear',
                animationEasingUpdate: 'linear'
            }
            this.chart.setOption(option)
            this.time = setInterval(() => {
                if (option.dataZoom[0].endValue == arr.length) {
                    option.dataZoom[0].endValue = 6;
                    option.dataZoom[0].startValue = 0
                } else {
                    option.dataZoom[0].endValue = option.dataZoom[0].endValue + 1
                    option.dataZoom[0].startValue = option.dataZoom[0].startValue + 1
                }
                if (!this.chart) {
                clearTimeout(this.time)
                return
            }
                this.chart.setOption(option)
            }, 1000)
        }
    }
}

</script>
